import React from 'react';
import { testimonials } from '../data/mock';
import { Quote } from 'lucide-react';

const Testimonials = () => {
  return (
    <section id="testimonials" className="section-padding testimonials-section">
      <div className="container">
        <div className="section-header">
          <h2 className="hero-medium">Avis Clients</h2>
          <p className="body-large section-intro">
            Ils ont expérimenté nos soins et partagent leur ressenti.
          </p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={testimonial.id} className="testimonial-card fade-in-up" style={{ animationDelay: `${index * 0.1}s` }}>
              <Quote size={32} className="quote-icon" />
              <p className="body-regular testimonial-text">
                {testimonial.text}
              </p>
              <div className="testimonial-author">
                <p className="heading-3">{testimonial.name}</p>
                <p className="body-small testimonial-service">{testimonial.service}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;